import type { SdkConfiguration } from '../types';
import { LicenseInfo, withSBErrorHandling } from '../types';

import { ScanbotBarcodeSDKPlugin } from './definitions';

/**
 * @internal
 * @hidden
 */
export const ScanbotBarcodeSdkImpl = {
  initialize(config: SdkConfiguration): Promise<LicenseInfo> {
    return withSBErrorHandling(async () => new LicenseInfo(await ScanbotBarcodeSDKPlugin.initialize(config)));
  },

  getLicenseInfo(): Promise<LicenseInfo> {
    return withSBErrorHandling(async () => new LicenseInfo(await ScanbotBarcodeSDKPlugin.getLicenseInfo()));
  },

  cleanupStorage() {
    return withSBErrorHandling(ScanbotBarcodeSDKPlugin.cleanupStorage);
  },

  mockCamera(params: { imageFileUri: string; refreshOnEachFrame?: boolean }): Promise<void> {
    return withSBErrorHandling(() => ScanbotBarcodeSDKPlugin.mockCamera(params));
  },
};
